import { CalendarMonth, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { addMonths, addWeeks, endOfMonth, format } from 'date-fns';
import { useCallback } from 'react';
import { useLocale } from '../contexts/locale.context';
import { dateLocaleMap } from '../utils/dates';
import PrimaryButton from './PrimaryButton';

type Props = {
  range: [number, number];
  setRange: (range: [number, number]) => void;
  scale: 'week' | 'month';
};

export const DateRangeButtons = ({ range, setRange, scale }: Props) => {
  const { lang } = useLocale();

  const handleRightClick = useCallback(() => {
    if (scale === 'month') {
      const start = addMonths(range[0], 1);
      const end = endOfMonth(start);
      setRange([start.getTime(), end.getTime()]);
    }
    if (scale === 'week') {
      const start = addWeeks(range[0], 1);
      const end = addWeeks(range[1], 1);
      setRange([start.getTime(), end.getTime()]);
    }
  }, [range, scale, setRange]);

  const handleLeftClick = useCallback(() => {
    if (scale === 'month') {
      const start = addMonths(range[0], -1);
      const end = endOfMonth(start);
      setRange([start.getTime(), end.getTime()]);
    }
    if (scale === 'week') {
      const start = addWeeks(range[0], -1);
      const end = addWeeks(range[1], -1);
      setRange([start.getTime(), end.getTime()]);
    }
  }, [range, scale, setRange]);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <PrimaryButton color="secondary" onClick={handleLeftClick}>
        <KeyboardArrowLeft />
      </PrimaryButton>
      <CalendarMonth color="action" />
      {scale === 'month' && (
        <Typography variant="h6">{format(range[0], 'LLLL yyyy', { locale: dateLocaleMap[lang] })}</Typography>
      )}

      {scale === 'week' && (
        <Typography variant="h6">
          {`${format(range[0], 'd MMM', { locale: dateLocaleMap[lang] })} - ${format(range[1], 'd MMM', {
            locale: dateLocaleMap[lang],
          })}`}
        </Typography>
      )}

      <PrimaryButton color="secondary" onClick={handleRightClick}>
        <KeyboardArrowRight />
      </PrimaryButton>
    </Box>
  );
};
